module.exports = __webpack_public_path__ + "static/media/um.50162f60.svg";